<template>
  <footer class="footer section-space">
    <div class="container container_wide footer__container">
      <div class="footer__section footer__section_logo">
        <a href="" class="footer__logo logo logo_dark">
          <figure>
            <img src="/img/logo.svg"class="logo__img" alt="Adway Logo" title="Adwayusa">
            <figcaption class="logo__caption">Adwayusa Logotype</figcaption>
          </figure>
        </a>
        <div class="footer__slogan">Ads that move</div>
      </div>
      <div class="footer__section">
        <h3 class="footer__section-title footer__section-title_link"><a href="login" class="btn">Sign In</a></h3>
        <div class="footer__section-body">
          <a href="signupadvertiser" class="btn footer__link">Sign Up as Advertiser</a>
          <a href="signupdriver" class="btn footer__link">Sign Up as Driver</a>
          <a href="privacypolicy" class="btn footer__link">Privacy Policy</a>
          <a href="advertisertc" class="btn footer__link">Advertiser Terms and Conditions</a>
          <a href="drivertc" class="btn footer__link">Driver Terms and Conditions</a>
        </div>
      </div>
      <div class="footer__section">
        <h3 class="footer__section-title">Contact</h3>
        <div class="footer__section-body">
          <dl class="contacts">
            <div class="contacts__item">
              <dt>Email:</dt>
              <dd><a href="mailto:info@adwayusa.com" class="btn footer__link">info@adwayusa.com</a></dd>
            </div>
            <div class="contacts__item">
              <dt>Phone:</dt>
              <dd><a href="tel:+12133214844" class="btn footer__link">(+1) 213-321-4844</a></dd>
            </div>
          </dl>
          <div class="social-media">
            <a href="https://www.facebook.com/driveadway" target="_blank" class="social-media__btn btn">
              <FacebookIcon className="social-media__btn-icon" />
            </a>
            <a href="https://twitter.com/adwayusa" target="_blank" class="social-media__btn btn">
              <TwitterIcon className="social-media__btn-icon" />
            </a>
            <a href="https://www.linkedin.com/company/adwayusa" target="_blank" class="social-media__btn btn">
              <LinkedinIcon className="social-media__btn-icon" />
            </a>
            <!-- <a href="https://instagram.com/adwayusa" target="_blank" class="social-media__btn btn">
              <InstagramIcon className="social-media__btn-icon" />
            </a> -->
          </div>
        </div>
      </div>
      <div class="footer__section footer__section_newsletter">
        <h3 class="footer__section-title">Newsletter</h3>
        <form id="subscribe-form" class="subscribe" @submit.prevent="onSubscribe">
          <div class="subscribe__field">
            <div class="subscribe__title">Email</div>
            <input type="email" :value="subscriptionEmail" @input="handleEmailInput" name="email" class="subscribe__input" required>
          </div>
          <button class="subscribe__btn btn_primary btn">Subscribe</button>
          <!-- <button data-sitekey="6Lf1-9IqAAAAADjbE0s_OUWPpM0GFYaS2aKGFx6J"
            data-action='submit'
            data-callback='footerSubscribeSubmit'
            class="subscribe__btn btn_primary btn g-recaptcha">
            Subscribe</button> -->
        </form>
      </div>
    </div>
    <div class="drawers">
      <div :class="['drawer drawer_dialog drawer_error', showErrorDialog && 'drawer_open']" data-drawer="subscription-error">
        <div class="drawer__panel" data-elem="drawer.panel">
          <div class="drawer__header">
            <div class="drawer__title">Error</div>
            <button class="close-btn close-btn_sm drawer__close-btn" @click="closeErrorDialog"></button>
          </div>
          <div class="drawer__body">
            Subscription failed.<br>
            Please try again later.<br>
            {{ errorMsg }}
          </div>
        </div>
      </div>
      <div :class="['drawer drawer_dialog drawer_success', showSuccessDialog && 'drawer_open']" data-drawer="subscription-success">
        <div class="drawer__panel" data-elem="drawer.panel">
          <div class="drawer__header">
            <div class="drawer__title">Success</div>
            <button class="close-btn close-btn_sm drawer__close-btn" @click="closeSuccessDialog"></button>
          </div>
          <div class="drawer__body">
            Subscription successful!<br>You've been added to our mailing list.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import FacebookIcon from "../svg/Facebook.vue";
import LinkedinIcon from "../svg/Linkedin.vue";
import TwitterIcon from "../svg/Twitter.vue";
import InstagramIcon from "../svg/Instagram.vue";

export default {
  name: 'FooterVue',
  data: function() {
    return {
      showErrorDialog: false,
      showSuccessDialog: false,
      errorMsg: null,
      subscriptionEmail: "",
    };
  },
  components: {
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon,
    InstagramIcon
  },
  methods: {
    handleEmailInput(e) {
      this.subscriptionEmail = e.target.value;
    },
    closeSuccessDialog() {
      this.showSuccessDialog = false;
    },
    closeErrorDialog() {
      this.showErrorDialog = false;
    },
    async onSubscribe(e) {
      const API_KEY = "11EB8AC1618FB46A9AAE12EE88221E3B";

      try {
        const response = await fetch("https://api.adwayusa.com/add/email", {
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          body: JSON.stringify({
            API_KEY,
            data: {
              email: this.subscriptionEmail,
            },
          }),
        });

        if (response.ok) {
          this.showSuccessDialog = true;
        } else {
          this.errorMsg = response.statusText;
          this.showErrorDialog = true;
        }
      } catch(ex) {
          console.error(ex);
        this.errorMsg = `Error: ${ex.message}`;
        this.showErrorDialog = true;
      }
    },
    error(e) {
      console.error(e);
    },
    msg(m) {
      console.log(e);
    }
  }
}
</script>
<style scoped>
.footer {
	color: var(--light-900);
	background-color: var(--dark-900);
  overflow: hidden;
}
.footer__container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 60px 40px;
}
@media (max-width: 1200px) {
  .footer__container {
    grid-template-columns: 1fr 1fr minmax(280px, 1fr);
  }
}
@media (max-width: 860px) {
  .footer__container {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 640px) {
  .footer__container {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 1200px) {
  .footer__section_logo {
    grid-column: auto/span 3;
  }
}
@media (max-width: 860px) {
  .footer__section_logo {
    grid-column: auto/span 1;
  }
}
.footer__section_newsletter {
  max-width: 400px;
}
.footer__logo {
  --width: 200px;
  --height: 32px;
  margin-bottom: 10px;
}
.footer__logo img {
  filter: invert(1);
}
.footer__slogan {
  font-size: 20px;
}
.footer__section-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
}
.footer__section-title_link {
  --color: var(--light-900);
  --hover-color: var(--light-907);
}
.footer__section-body {
  display: grid;
  gap: 18px;
  justify-items: start;
}
.footer__link {
  --color: var(--light-900);
  --hover-color: var(--light-907);
}
.social-media {
	display: flex;
	flex-wrap: wrap;
	gap: 18px;
  font-size: 24px;
	--color: var(--light-900);
	--hover-color: var(--light-907);

}
.social-media__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 4px;
}
.contacts {
	display: grid;
	gap: 18px;
}
.contacts__item {
  display: flex;
  gap: 0.6em;
}
.subscribe {
	display: grid;
	gap: 8px;
}
.subscribe__title {
  margin-bottom: 18px;
}
.subscribe__input {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 14px 20px;
  border-radius: 5px;
  outline: 2px solid transparent;
  outline-offset: 0px;
  transition: outline-color 0.3s;
}
.subscribe__input:focus {
  outline-color: #8a3c90;
}
.subscribe__btn {
  width: 100%;
  --color: var(--dark-900);
  --bg-color: var(--gray-500);
  --hover-bg-color: var(--gray-300);
}
</style>
